// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__1dVQm","title":"Header_title__1N98u","side":"Header_side__3SyIp"};